import React, { useState, useMemo } from 'react';

import { Layout } from 'antd';

import { useContactPicturesAndVideos } from '@hooks/API/Contact/UseContactMedia';
import useDataPlaceholder from '@hooks/Utils/UseDataPlaceholder';

import NwDrawer from '@components/Gui/NwDrawer';

import SelectPictureHeader from './SelectPictureHeader';
import SelectPictureList from './SelectPictureList';

const SelectPictureDrawer = ({ onSelectPicture, modelID, onClose, afterUpload }) => {
    const replacePlaceHolder = useDataPlaceholder();
    const { data: documents, isFetching } = useContactPicturesAndVideos(modelID);
    const [size, setSize] = useState('medium');
    const [sort, setSort] = useState('time');
    const [showMedia, setShowMedia] = useState({
        isShowPictures: true,
        isShowVideos: false,
    });
    const [tags, setTags] = useState([]);
    const [uploader, setUploader] = useState();

    const [uploadedSince, setUploadedSince] = useState();
    const [uploadedUntil, setUploadedUntil] = useState();

    const [uploadingPictures, setUploadingPictures] = useState([]);
    const [invalidUploadingPictures, setInvalidUploadingPictures] = useState([]);

    const handleUpdateSort = (value) => {
        setSort(value);
    };

    const handleUpdateSize = (value) => () => {
        setSize(value);
    };

    const handleUpdateShowMedia = (updatedShowMedia) => {
        setShowMedia(updatedShowMedia);
    };

    const handleUpdateTags = (updatedTags) => {
        setTags(updatedTags);
    };

    const handleChangeUploader = (value) => {
        setUploader(value);
    };

    const handleUploadedSinceChange = (value) => {
        setUploadedSince(value);
    };

    const handleUploadedUntilChange = (value) => {
        setUploadedUntil(value);
    };

    const displayedDocuments = useMemo(() => {
        let documentList = [];
        if (documents && documents.length) {
            documentList = documents.filter((document) => {
                if (
                    (document.Type === 'Photo' && showMedia.isShowPictures) ||
                    (document.Type === 'Video' && showMedia.isShowVideos)
                ) {
                    return true;
                }
                return false;
            });

            if (uploader) {
                documentList = documentList.filter((document) => document.UserCreated === uploader);
            }

            documentList = documentList.filter((document) => {
                for (const tag of tags) {
                    if (!document.Tags.find((item) => item.ID === tag)) {
                        return false;
                    }
                }
                return true;
            });

            const uploadedSinceDate = replacePlaceHolder(uploadedSince);
            const uploadedUntilDate = replacePlaceHolder(uploadedUntil);
            documentList = documentList.filter((document) => {
                if (uploadedSince) {
                    if (new Date(uploadedSinceDate) > new Date(document.DateCreated)) return false;
                }
                if (uploadedUntil) {
                    if (new Date(uploadedUntilDate) < new Date(document.DateCreated)) return false;
                }
                return true;
            });
        }
        return documentList;
    }, [uploader, uploadedSince, uploadedUntil, showMedia, documents, tags, replacePlaceHolder]);

    return (
        <NwDrawer width="90vw" title="Add Media" onClose={onClose} padding={0}>
            <Layout style={{ minHeight: '100vh' }}>
                <SelectPictureHeader
                    modelId={modelID}
                    documents={documents ? documents : []}
                    loading={isFetching}
                    size={size}
                    sort={sort}
                    onChangeSort={handleUpdateSort}
                    onChangeSize={handleUpdateSize}
                    showMedia={showMedia}
                    onUpdateShowMedia={handleUpdateShowMedia}
                    tags={tags}
                    onUpdateTags={handleUpdateTags}
                    uploader={uploader}
                    onChangeUploader={handleChangeUploader}
                    uploadedSince={uploadedSince}
                    onChangeUploadedSince={handleUploadedSinceChange}
                    uploadedUntil={uploadedUntil}
                    onChangeUploadedUntil={handleUploadedUntilChange}
                />
                {/* <NwUpload
                    maxSize={50}
                    showList={false}
                    types={["image"]}
                    onUploadStart={(uploadInfo) => {
                        if (uploadInfo.event) {
                            setUploadingPictures(uploadInfo.fileList)
                        }
                    }}
                    onShowInvalidFiles={invalidFiles => setInvalidUploadingPictures(invalidFiles)}
                    onUploadEnd={() => {
                        forceReloadContact(modelID);
                    }}
                    endpoint={`documents/uploadsingle/2?contactID=${modelID}`}
                >Upload new pictures</NwUpload> */}
                <SelectPictureList
                    modelID={modelID}
                    size={size}
                    sort={sort}
                    documents={displayedDocuments}
                    onSelectPicture={onSelectPicture}
                />
            </Layout>
        </NwDrawer>
    );
};

export default SelectPictureDrawer;
